import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Placeholder from '../assets/thumbnails/rapid-boost.jpeg';
import Shine from '../assets/Shine.svg'
import Accordion from '../components/support/Accordion';
import DiscordIcon from '../assets/discord-icon.svg';

const Support = () => {

    const [selectedCard, setSelectedCard] = useState('faqs');

    const navigate = useNavigate();

    const cards = [
        {
            title: "account",
            label: "Account & Email Verification",
        },
        {
            title: "payments",
            label: "Payment, Billing & Refunds",
        },
        {
            title: "videos",
            label: "Video Playback & Streaming",
        },
        {
            title: "devices",
            label: "Device Access & Security",
        },
        // {
        //     title: "contributions",
        //     label: "Contributions & Character Paths",
        // },
        // {
        //     title: "troubleshooting",
        //     label: "Troubleshooting & Bug Reports",
        // },
        {
            title: "faqs",
            label: "Frequently Asked Questions",
        }
    ];

    return (
        <div className="wrapper">
            <div id="content-wrap">
                <Navbar />
                <div className="d-flex flex-column justify-content-center align-items-center pt-md-5" style={{marginTop: "60px"}}>
                  {/* <div className='d-flex flex-wrap justify-content-center gap-4 pt-4'> */}
                    <h2>Help & Support</h2>
                    <p className='col-8 text-center'>Everything you need to troubleshoot issues, manage your account, and use the site effectively.</p>
                    <div className='d-flex pt-2'>
                        <img src={Shine} alt='Shine' className='pe-1' />
                        <img src={Shine} alt='Shine' className='pe-1' />
                        <img src={Shine} alt='Shine' className='pe-1' />
                    </div>
                    <div className='container'>
                        <div className='row justify-content-center my-4 w-75'>
                            {cards.map((cards) =>
                                <div className='col-10 col-sm-6 col-md-6 col-lg-4 mb-4' style={{cursor: 'pointer'}} >
                                    <div 
                                        className="rounded d-flex justify-content-center align-items-center text-center p-5" 
                                        style={{
                                            backgroundColor: selectedCard === cards.title ? '#FFCC19' : '#000000', 
                                            color: selectedCard === cards.title ? 'black' : 'white',
                                            height: '200px',
                                            // border: selectedCard === cards.title ? '2px solid #FFCC19' : '1px solid #E5E5E5',
                                            // transition: 'border 0.3s',
                                        }}
                                        onClick={() => setSelectedCard(cards.title)}
                                    >
                                        <h4>{cards.label}</h4>
                                    </div>
                                </div>
                            )}
                            {/* Detailed support content based on selectedCard would go here */}
                            <h2 className='my-4 text-center'>{cards.find(card => card.title === selectedCard)?.label}</h2>
                            <Accordion selectedCard={selectedCard} />
                            <div className='text-center my-5'>

                                    <img src={DiscordIcon} alt='Discord' style={{width: '120px', marginTop: '10px'}}/>
                                <h2>Still need help?</h2> 
                                    <p>Join the <strong>Melee Academy Discord</strong> for further assistance.</p>
                                <button className='rounded w-25 mt-3' style={{backgroundColor: '#FFCC19', color: 'black', height: '45px', fontWeight: 600}} onClick={() => window.open('https://discord.gg/68dtHFJF79', '_blank')}>Join</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Support